import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PackagesGridViewModel from '../../models/PackagesGrid/PackagesGridViewModel';
import "./PackageItem.css";
import EligibilityConstants from '../../constants/eligibilityConstants';
import GlobalLoaderStore from '../../stores/GlobalLoaderStore';
import PackageStore from '../../stores/PackagesStore';


interface PackageItemProps {
    Package: PackagesGridViewModel,
    RedirectToUpdate: () => void,
    Packages?: PackageStore,
    globalLoader?: GlobalLoaderStore,
    cy_data?: string
}

interface PackageItemState {
    Package: PackagesGridViewModel | null;
}

@inject("packages", "globalLoader")
@observer
export default class EligibilityItem extends Component<PackageItemProps, PackageItemState> {
    constructor(props: PackageItemProps) {
        super(props);
        this.state = {
            Package: props.Package
        }
    }


    render() {
        return <tr cy-data={this.props.cy_data}>
            <td data-th={EligibilityConstants.GCID_RELATED_BUNDLE_NAME} className='csod-table-td'>{this.props.Package.Name}</td>
            <td data-th={EligibilityConstants.GCID_RELATED_BUNDLE_ID} className='csod-table-td' >{this.props.Package.Id}</td>
            <td data-th={EligibilityConstants.GCID_RELATED_BUNDLE_IS_FOR_CURATION} className='csod-table-td' >{JSON.stringify(this.props.Package.IsForCuration)}</td>
            <td data-th={EligibilityConstants.GCID_RELATED_BUNDLE_CREATED_BY_CORP} className='csod-table-td'>{JSON.stringify(this.props.Package.IsCreatedByCorp)}</td>
        </tr>
    }
}
